module.exports = __webpack_public_path__ + "static/media/icon_qpm.57672127.svg";